import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/http";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const refresh =
        sessionStorage.getItem("refresh");

      try {
        if (refresh) {
          // backend așteaptă: {"refresh": "..."}
          await api.post("/authen/logout/", { refresh });
        }
      } catch (err) {
        // nu blocăm logout-ul local dacă backend-ul are probleme
        console.warn("Logout backend error (ignored)", err);
      } finally {
        // 🔥 curățăm TOT (session + local) ca să nu rămână tokenuri
        const keys = ["access", "refresh", "is_superuser"];
        keys.forEach((k) => {
          sessionStorage.removeItem(k);
        });

        navigate("/", { replace: true });
      }
    };

    run();
  }, [navigate]);

  return <div>Logging out...</div>;
}

export default Logout;